import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { type InterviewPanelMemberData } from '../../../DRCAssessment';

type GetInterviewPanel = {
  interviewPanelListData: InterviewPanelMemberData[];
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useGetInterviewPanel = (
  applicationId: string,
): GetInterviewPanel => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($filter: NominationFilter!) {
        nominations(filter: $filter) {
          interviewPanel {
            panelMembers {
              netId
              title
              jobTitle
              givenName
              surname
              department
              institution
              telephoneNumber
              email
              isPanelChair
              rank
              post
            }
          }
        }
      }
    `,
    {
      variables: { filter: { application: { _id: { eq: applicationId } } } },
      skip: !applicationId,
    },
  );

  const interviewPanelListData: InterviewPanelMemberData[] = (
    data?.nominations?.[0]?.interviewPanel?.panelMembers ?? []
  ).map((member: any) => {
    return {
      netId: member?.netId ?? '',
      title: member?.title ?? '',
      jobTitle: member?.jobTitle ?? '',
      givenName: member?.givenName ?? '',
      surname: member?.surname ?? '',
      institution: member?.institution ?? '',
      department: member?.department ?? '',
      email: member?.email ?? '',
      isPanelChair: member?.isPanelChair ?? false,
      post: member?.post ?? '',
      rank: member?.rank ?? '',
    };
  });

  return {
    interviewPanelListData,
    loading,
    error,
    refetch,
  };
};
